import type { ErrorResponseBody, SuccessResponseBody } from "./types";

export function isErrorResponseBody(
	value: unknown,
): value is ErrorResponseBody {
	const typedValue = value as ErrorResponseBody;
	try {
		return Boolean(
			typeof typedValue?.error?.message === "string" &&
				typedValue.body === null,
		);
	} catch {
		return false;
	}
}

export function isSuccessResponseBody<
	TData extends Record<PropertyKey, unknown> | Array<unknown>,
>(value: unknown): value is SuccessResponseBody<TData> {
	const typedValue = value as SuccessResponseBody<TData>;
	try {
		return Boolean(
			typedValue.body &&
				typeof typedValue.body === "object" &&
				typedValue.error === null,
		);
	} catch {
		return false;
	}
}
